import { DASHBOARD_PATH } from "../constants/AppConstants";

export const DASHBOARD_PATHS = {
  CHECK_OUT: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.CHECK_OUT}`,
  LANDING: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.LANDING}`,
  OLD_ORDERS: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.OLD_ORDERS}`,
  MENU: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.MENU}`,
  MENU_DISPLAY: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.MENU_DISPLAY}`,
  ADDRESS_ADD: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.ADD_ADDRESS}`,
  COUNTER_LIST: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.COUNTER}`,
  SETTINGS: `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.SETTINGS}`,
};
